export default "__VITE_ASSET__COVPlNeN__"